import { put, call, takeLatest } from "redux-saga/effects";
import * as Api from "../api";
import * as ActionConstants from "../actions/actionConstants";
import { logout } from '../../WorkkardDetail/Saga/common';
import {LOG_APPLICATON_ERROR} from "../../../containers/WorkkardDetail/actions/actionConstants";
import {  ErrorCode } from '../../../containers/WorkkardDetail/constants';

export function* fetchUserRecentSearches({payload}){
    try{
        const { recentSearches, status } = yield call(Api.getRecentSearchListApi, ActionConstants.FETCH_USER_RECENT_SEARCHES_REQUEST,payload);
        if(status==200){
            yield put({
                type: ActionConstants.FETCH_USER_RECENT_SEARCHES_SUCCESS,
                payload: recentSearches
            })
        }
        else if(status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:status,isErrorScreen:false}
            });
        }    
    }
    catch(error){

    }
    finally{
    }
}

export function* removeRecentSearchItem({payload}){
    try{
        yield put({ type: ActionConstants.SHOW_GLOBAL_SEARCH_LOADER });
        const {status} = yield call(Api.removeRecentSearchItemApi, ActionConstants.REMOVE_RECENT_SEARCH_ITEM_REQUEST,payload);
        if(status==200){
            yield put({
                type: ActionConstants.REMOVE_RECENT_SEARCH_ITEM_SUCCESS,
                payload: payload
            })
        }
        else if(status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:status, isErrorScreen:false}
            });
        }        
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_GLOBAL_SEARCH_LOADER });
    }
}

// API returns camelCase keys; GlobalSearch/index.jsx reads PascalCase ones.
const mapWorkkardSuggestion = (item = {}) => ({
    WorkkardId: item.workkardId,
    WorkkardNumber: item.workkardNumber,
    WkDescription: item.wkDescription,
    WorkkardNameForClaimWk: item.workkardNameForClaimWk,
    CaseNumber: item.caseNumber,
    CarrierClaimNumber: item.carrierClaimNumber,
});

export function* getWorkkardSearchList({payload}) {
    try {
        yield put({ type: ActionConstants.SHOW_GLOBAL_SEARCH_LOADER });
        const response = yield call(Api.getWorkkardSearchListApi, ActionConstants.GET_WORKKARD_SEARCH_LIST_REQUEST,payload);
        if(response){
            const suggestion = Array.isArray(response.suggestion) ? response.suggestion : [];
            yield put({
                type: ActionConstants.GET_WORKKARD_SEARCH_LIST_SUCCESS,
                payload: suggestion.map(mapWorkkardSuggestion)
            })
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status: 500, isErrorScreen:false }
            });
        }
    }
    catch (error) {

    }
    finally {
        yield put({ type: ActionConstants.HIDE_GLOBAL_SEARCH_LOADER });
    }
}

export function* fetchSearchResultData({payload}) {
    try {
        yield put({ type: ActionConstants.SHOW_GLOBAL_SEARCH_LOADER });

        const isUpdate=payload.isUpdate;
        delete payload.isUpdate;
        let key="",Data,Total,status;
        switch(payload.status){
            case 'workkards':  
                let workkardResponse = yield call(Api.fetchWorkkardSearchResultDataApi, ActionConstants.FETCH_WORKKARD_SEARCH_RESULT_DATA_REQUEST,payload);
                Data=workkardResponse.Data,Total=workkardResponse.Total,status=workkardResponse.status;
                key='workkardId';
                break;
            case 'activities':
                let activityResponse = yield call(Api.fetchActivitySearchResultDataApi, ActionConstants.FETCH_ACTIVITY_SEARCH_RESULT_DATA_REQUEST,payload);
                Data=activityResponse.Data,Total=activityResponse.Total,status=activityResponse.status;
                key='activityId';
                break;
            case 'notes':
                let notesResponse = yield call(Api.fetchNotesSearchResultDataApi, ActionConstants.FETCH_NOTES_SEARCH_RESULT_DATA_REQUEST,payload);
                Data=notesResponse.Data,Total=notesResponse.Total,status=notesResponse.status;
                key='Id';
                break;
            case 'files':
                let filesResponse = yield call(Api.fetchFilesSearchResultApi, ActionConstants.FETCH_FILES_SEARCH_RESULT_DATA_REQUEST,payload);
                Data=filesResponse.Data,Total=filesResponse.Total,status=filesResponse.status;
                key='FkId';
                break;
            case 'activityowner':
                let activityOwnerResponse = yield call(Api.fetchActivityOwnerSearchResultDataApi, ActionConstants.FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_REQUEST,payload);
                Data=activityOwnerResponse.Data,Total=activityOwnerResponse.Total,status=activityOwnerResponse.status;
                key='activityId';
                break;
            case 'workkardsponsor':
                let workkardSponsorResponse = yield call(Api.fetchWorkkardOwnerSearchResultDataApi, ActionConstants.FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_REQUEST,payload);
                Data=workkardSponsorResponse.Data,Total=workkardSponsorResponse.Total,status=workkardSponsorResponse.status;
                key='workkardId';
                break;
            case 'activityassinee':
                let activityAssigneeResponse = yield call(Api.fetchActivityAssigneeSearchResultDataApi, ActionConstants.FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_REQUEST,payload);
                Data=activityAssigneeResponse.Data,Total=activityAssigneeResponse.Total,status=activityAssigneeResponse.status;
                key='activityId';
                break;
            default:
                break;

        }

        if(isUpdate){
            yield put({
                type: ActionConstants.UPDATE_SEARCH_RESULT_DATA_SUCCESS,
                payload: {Data,Total,skip:payload.skip,take:payload.take,key:key,status:status,type:payload.status}
            })
        }
        else{
            yield put({
                type: ActionConstants.FETCH_SEARCH_RESULT_DATA_SUCCESS,
                payload: {Data,Total,skip:payload.skip,take:payload.take,status:status,type:payload.status}
            })
        }
        
    }
    catch (error) {
    }
    finally {
        yield put({ type: ActionConstants.HIDE_GLOBAL_SEARCH_LOADER });
    }
}

export function* addglobalsearchusage({payload}){
    try {
        const {status} = yield call(Api.addglobalsearchusageApi, ActionConstants.ADD_GLOBAL_SEARCH_USAGE_REQUEST, payload);
    }
    catch (error) {

    }
    finally {
    }
}

export function* getTopbarTabsCount({ payload }) {
    try {
        yield put({ type: ActionConstants.SHOW_GLOBAL_SEARCH_LOADER });
        const { Data, status } = yield call(Api.getTopbarTabsCount, ActionConstants.GET_TOPBAR_TABS_COUNT, { key: payload.key });
        if (status == 200) {
            yield put({
                type: ActionConstants.GET_TOPBAR_TABS_COUNT_SUCCESS,
                payload: Data
            });
            yield* fetchSearchResultData({payload});
        }
        else if(status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:status, isErrorScreen:false  }
            });
        }    
    }
    catch (error) {

    }
    finally {
        yield put({ type: ActionConstants.HIDE_GLOBAL_SEARCH_LOADER });
    }
}

export default [
    takeLatest(ActionConstants.GET_WORKKARD_SEARCH_LIST_REQUEST, getWorkkardSearchList),
    takeLatest(ActionConstants.FETCH_USER_RECENT_SEARCHES_REQUEST,fetchUserRecentSearches),
    takeLatest(ActionConstants.REMOVE_RECENT_SEARCH_ITEM_REQUEST,removeRecentSearchItem),
    takeLatest(ActionConstants.FETCH_SEARCH_RESULT_DATA_REQUEST,fetchSearchResultData),
    takeLatest(ActionConstants.ADD_GLOBAL_SEARCH_USAGE_REQUEST,addglobalsearchusage),
    takeLatest(ActionConstants.GET_TOPBAR_TABS_COUNT, getTopbarTabsCount),
];
